const electronLatest = '/electron/latest'

export { electronLatest }
